import type { StaffRegisterStatus } from "services/api/company/timeReports.service";

export type StaffRegisterStatusTone = "success" | "warning" | "neutral";

/** Map a staff register status to the UI tone used by the status pill. */
export const toStaffRegisterStatusTone = (
  status: StaffRegisterStatus,
): StaffRegisterStatusTone => {
  if (status === "Started") return "success";
  if (status === "New") return "warning";
  return "neutral";
};

/** Map a staff register status to the optional icon shown in the status pill. */
export const toStaffRegisterStatusIconName = (
  status: StaffRegisterStatus,
): string | null => {
  if (status === "Started") return "v2/checkmark";
  if (status === "New") return "v2/clock";
  return null;
};

/** Map a staff register status to a translated user-facing status label. */
export const toStaffRegisterStatusText = (
  status: StaffRegisterStatus,
  translate: (key: string) => string,
): string => {
  switch (status) {
    case "Stamped":
      return translate("TimeReports.Stamped");
    case "TimeReported":
      return translate("TimeReports.TimeReported");
    case "Started":
      return translate("TimeReports.OnSite");
    case "New":
      return translate("TimeReports.NotCheckedIn");
    default: {
      const exhaustiveCheck: never = status;
      return exhaustiveCheck;
    }
  }
};
